import { notification } from 'antd'
import React from 'react'

import { NotificationContext } from '../NotificationContext'

type NotificationProviderProps = {
  children: React.ReactNode
}

export function NotificationProvider({
  children,
}: NotificationProviderProps): JSX.Element {
  const [notificationInstance, contextHolder] = notification.useNotification()

  return (
    <NotificationContext.Provider
      value={{ notification: notificationInstance }}
    >
      {contextHolder}
      {children}
    </NotificationContext.Provider>
  )
}
